export default "__VITE_ASSET__Dlj_JeF$__"